import { render, staticRenderFns } from "./AddMWEMonthlyDialog.vue?vue&type=template&id=52cdb153&scoped=true"
import script from "./AddMWEMonthlyDialog.vue?vue&type=script&lang=js"
export * from "./AddMWEMonthlyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cdb153",
  null
  
)

export default component.exports